import React from 'react'
import "./Footer1.css"
const Footer1 = () => {
  return (
    <section className="f-wrapper">
      <div className="paddings innerWidth f-container">
        <div className="flexColCenter inner-container">
          <span className='red-text'>Get Started</span>
          <span>subscribe</span>
          <span></span>
        <div className="button">
          <a href="/">Connected</a>
        </div>
        </div>
      </div>
    </section>
  )
}

export default Footer1
